module.exports = __webpack_public_path__ + "static/media/6.d3dfcf3c.jpg";